/**
 * Data Export API Service
 * Handles all GDPR data export API calls
 */
import api from './api';
import type {
  DataExportListResponse,
  DataExportInitiateRequest,
  DataExportInitiatedResponse,
  DataExportRequest,
  DataExportDownloadResponse,
} from '@/types/dataExport';

// ============================================================================
// Data Export API
// ============================================================================

export const dataExportApi = {
  /**
   * Initiate a new data export request
   * Requires step-up authentication (MFA code or password)
   */
  initiateExport: async (request: DataExportInitiateRequest): Promise<DataExportInitiatedResponse> => {
    return api.post<DataExportInitiatedResponse>('/users/me/data-export/request', request);
  },

  /**
   * List user's data export requests
   * @param limit - Maximum number of exports to return (default: 10, max: 50)
   */
  listExports: async (limit: number = 10): Promise<DataExportListResponse> => {
    return api.get<DataExportListResponse>('/users/me/data-export', { limit });
  },

  /**
   * Get status of a specific data export request
   * @param exportId - UUID of the export request
   */
  getExport: async (exportId: string): Promise<DataExportRequest> => {
    return api.get<DataExportRequest>(`/users/me/data-export/${exportId}`);
  },

  /**
   * Get download URL for a completed data export
   * The URL is a presigned S3 URL valid for 1 hour
   * @param exportId - UUID of the export request
   */
  getDownloadUrl: async (exportId: string): Promise<DataExportDownloadResponse> => {
    return api.get<DataExportDownloadResponse>(`/users/me/data-export/${exportId}/download`);
  },
};

export default dataExportApi;
